import { TCondition } from '../types';
import { IApplicationState } from '../../../../types/types';
import { EHintKey, getHintConfig } from '../constants';
import { getHintCanShow } from '../store/hint/selectors/getHintCanShow';

export const openedLastBoardCondition: TCondition = (
    state: IApplicationState
) => {
    const hint = getHintConfig(EHintKey.OPENED_LAST_BOARD);
    if (!hint) return false;

    return !!getHintCanShow(state, EHintKey.OPENED_LAST_BOARD);
};
